import { ChevronRightIcon } from '@heroicons/react/24/outline';
import { getStatusBadgeClass } from '../../../../services/oathAgencyVitalsService';

// Stat item for data cards - entire row is clickable
const StatItem = ({ label, count, value, status = 'normal', tooltip, onClick }) => {
  const badgeClass = getStatusBadgeClass(status);
  const isClickable = !!onClick;

  return (
    <div
      className={`flex items-center justify-between py-1.5 qhd:py-2 4k:py-2.5 border-b border-gray-100 dark:border-gray-700 last:border-0 -mx-2 px-2 ${
        isClickable
          ? 'cursor-pointer hover:bg-primary/5 dark:hover:bg-primary/10 rounded transition-all group hover:border-primary/20'
          : ''
      }`}
      title={tooltip || undefined}
      onClick={isClickable ? onClick : undefined}
      role={isClickable ? 'button' : undefined}
      tabIndex={isClickable ? 0 : undefined}
      onKeyDown={isClickable ? (e) => e.key === 'Enter' && onClick() : undefined}
    >
      <span className={`text-sm qhd:text-base 4k:text-lg text-gray-600 dark:text-gray-300 ${isClickable ? 'group-hover:text-primary dark:group-hover:text-primary-light' : ''}`}>
        {label}
      </span>
      <div className="flex items-center gap-2 qhd:gap-3">
        {count !== null && count !== undefined && (
          <span className={`text-xs qhd:text-sm 4k:text-base font-semibold px-1.5 py-0.5 qhd:px-2 qhd:py-1 rounded ${badgeClass}`}>
            {count}
          </span>
        )}
        {value && (
          <span className="text-xs qhd:text-sm 4k:text-base font-medium text-gray-500 dark:text-gray-400">
            {value}
          </span>
        )}
        {isClickable ? (
          <ChevronRightIcon className="w-3.5 h-3.5 qhd:w-4 qhd:h-4 4k:w-5 4k:h-5 text-gray-300 dark:text-gray-600 group-hover:text-primary dark:group-hover:text-primary-light group-hover:translate-x-0.5 transition-all" />
        ) : (
          <span className="w-3.5 h-3.5 qhd:w-4 qhd:h-4 4k:w-5 4k:h-5" />
        )}
      </div>
    </div>
  );
};

export default StatItem;
